import { useState, useRef, useEffect } from "react";
import BackgroundImageFromUrl from "../../components/parseImage/BackgroundImageFromUrl";
import { checkImage } from "../../constants/checkImage";
import ConstantStrings from "../../constants/ConstantStrings";
import { loadWidthImage } from "../../constants/loadWidthImage";
import QuestionNumberTag from "../../detail-components/QuestionNumberTag";
import ScrollRef from "../../detail-components/ScrollRef";
import jsonParser from "../helper/jsonParser";
import { cacheImage, getCacheImage, getImageUrl } from "../helper/parseImage";
import AudioIcon, { useAutoPlayAudio, handleClickAudio } from "./Assets/AudioIcon";

function QPrompt2_1({ data, order, isLast, playingAudioRef }) {
  const content = data?.content || data?.prompt;
  const contentText =
    content?.texts[0] !== null &&
      content?.texts[0] !== undefined &&
      content?.texts[0]?.length > 0
      ? jsonParser(content?.texts[0])
      : content?.texts[0];
  var imageStyle = {
    borderRadius: "0 1rem 0 0",
    width: "100%",
    height: "100%",
  };
  const [isLoading, setIsLoading] = useState(
    checkImage(content?.images[0])
      ? getCacheImage([content?.images[0]])
        ? false
        : true
      : false
  );
  var key = getImageUrl(content?.images[0]);
  useEffect(() => {
    loadWidthImage(key, (err, img) => {
      cacheImage([key]);
      setIsLoading(false);
    });
  }, [key]);

  const audioLink = content?.audioLink;
  const audioRef = useRef(new Audio(ConstantStrings.IMAGE_URL + audioLink));
  const [isAudioPlaying, setIsAudioPlaying] = useState(false);

  useAutoPlayAudio({
    content,
    audioRef,
    playingAudioRef,
    setIsAudioPlaying,
    slideId: data?._id || data.questionId,
    type: 0
  });

  return (
    <div>
      {!isLast &&
        !isLoading &&
        <ScrollRef />}

      <BackgroundImageFromUrl
        objectId={content?.backgroundImage}
        className={`${isLoading ? "is-hidden" : ""
          }  columns m-auto is-centered has-background-kurio-main-color-white has-text-kurio-main-color-black p-0 is-justify-content-flex-end`}
        style={{
          borderRadius: "1rem 1rem 0 0",
          fontSize: "1.25rem",
          lineHeight: "160%",
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center",
          maxWidth: "60rem",
        }}
      >
        <div
          className={`${isLoading ? "is-hidden" : ""
            } column is-half is-flex is-flex-direction-column is-align-items-flex-start is-justify-content-center`}
          style={{ padding: "2rem", gap: "1rem" }}
        >
          {data?.template.question !== null &&
            data?.template.question &&
            data?.template.question.length > 0 && (
              <QuestionNumberTag number={order === 0 ? data?.order : order} />
            )}

          <div
            className={`${isLoading ? "is-hidden" : ""} content`}
            style={{ maxWidth: "40rem" }}
          >
            {audioLink && playingAudioRef && <AudioIcon isPlaying={isAudioPlaying} onClick={() => handleClickAudio(audioRef, setIsAudioPlaying)} />}
            {contentText}
          </div>
        </div>
        <div
          className={` content-image column is-half p-0`}
          style={{ maxWidth: "50%" }}
        >
          <img style={imageStyle} src={key} alt={content?.images[0]}onError={(e)=>{ e.target.src = ConstantStrings.DEFAULT_IMAGE;e.target.style.width = "2.5rem";e.target.style.height = "2.5rem"; }} />
        </div>
      </BackgroundImageFromUrl>
    </div>
  );
}

export default QPrompt2_1;
